// /blog/technology/javascript/page.js
import React, { useEffect } from "react";
import { Container, Header, Segment, Icon, List} from "semantic-ui-react";
import { Link } from "react-router-dom";
import Feed from "@components/Feed";
import "@styles/BlogBody.css";

const Cybersecurity = () => {
  // Add Open Graph meta tags for Cybersecurity category page
  useEffect(() => {
    const updateMetaTag = (property, content, isProperty = true) => {
      const attribute = isProperty ? 'property' : 'name';
      let metaTag = document.querySelector(`meta[${attribute}="${property}"]`);
      
      if (!metaTag) {
        metaTag = document.createElement('meta');
        metaTag.setAttribute(attribute, property);
        document.head.appendChild(metaTag);
      }
      metaTag.setAttribute('content', content);
    };

    document.title = 'Cybersecurity Articles - Cloud CZR | Security & Data Protection';
    updateMetaTag('og:title', 'Cybersecurity Articles - Cloud CZR | Security & Data Protection');
    updateMetaTag('og:description', 'Learn about cybersecurity strategies, data protection, vulnerability assessment, and secure coding practices to protect against cyber threats.');
    updateMetaTag('og:url', window.location.href);
    updateMetaTag('og:type', 'website');
    updateMetaTag('og:image', `${window.location.origin}/assets/CloudChiRho.png`);
    updateMetaTag('og:image:alt', 'Cloud CZR, Cloudczr, cloudczr.com');
    
    updateMetaTag('description', 'Learn about cybersecurity strategies, data protection, vulnerability assessment, and secure coding practices to protect against cyber threats.', false);
    updateMetaTag('twitter:title', 'Cybersecurity Articles - Cloud CZR | Security & Data Protection', false);
    updateMetaTag('twitter:description', 'Learn about cybersecurity strategies, data protection, vulnerability assessment, and secure coding practices to protect against cyber threats.', false);
  }, []);

  const path = 'blog/technology/cybersecurity';
  return (
    <Container style={{ marginTop: "2em" }}>
      <Header as='h1' textAlign='center' icon style={{ color: '#a9885c', backgroundColor: '#702963' }}>
        <Icon name='user secret' style={{ color: '#a9885c' }}/>
        Cyber Secuirty Blog
        <Header.Subheader style={{ color: '#a9885c' }}>
        Cybersecurity encompasses various strategies, technologies, and processes designed to ensure the confidentiality, integrity, and availability of data, as well as to protect against cyber risks and vulnerabilities.
        </Header.Subheader>
      </Header>
      <Feed path={path} />
    </Container>
  );
};

export default Cybersecurity;
